module.exports = __webpack_public_path__ + "img/divider2.113fc40e.jpeg";